<template>
  <result-wrapper class="simple-result"
                  icon-name="events"
                  :element-data="elementData">
    <i class="bi bi-calendar-event ms-2 icons"></i>
    <span class="card-title ms-2">Events</span>
  </result-wrapper>
</template>

<script>
import ResultWrapper from "@/components/card/ResultWrapper.vue";

export default {
  name: "EventsBox",
  props: {
    elementKey: String,
    elementData: Object,
  },
  components: {
    ResultWrapper,
  }
};
</script>

<style lang="scss" scoped></style>